<div class="resumen-compra p-3 position-sticky">
  <h5 class="resumen-compra__title m-0">Resumen:</h5>
  <ul class="list">
    <li
      class="list__item"
      *ngFor="let metadata of configuracionDePago.metadata"
    >
      <span class="list__item_key">{{ metadata.dato }}:</span>
      {{ metadata.valor }}
    </li>
  </ul>

  <div
    class="row text-info"
    *ngIf="
      resumenDescuentos.descuentosAplicados &&
      resumenDescuentos.descuentosAplicados.length
    "
  >
    <div class="col-6">Subtotal:</div>
    <div class="col-6 text-right">
      {{ resumenDescuentos.subTotal | currency: 'COP':'symbol-narrow':'0.0-0' }}
    </div>
  </div>
  <div
    class="row text-info"
    *ngIf="
      resumenDescuentos.descuentosAplicados &&
      resumenDescuentos.descuentosAplicados.length
    "
  >
    <div class="col-6">Total descuento:</div>
    <div class="col-6 text-right">
      {{
        resumenDescuentos.totalDescuentos
          | currency: 'COP':'symbol-narrow':'0.0-0'
      }}
    </div>
  </div>
  <hr />
  <h4 class="resumen-compra__price" id="id-total-a-pagar">
    TOTAL A PAGAR:
    {{ resumenDescuentos.total | currency: 'COP':'symbol-narrow':'0.0-0' }}
  </h4>
</div>
